import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import useAxiosFetch from "../common/useAxiosFetch";
import { useAppContext } from "../AppContext";
import { useTranslation } from "react-i18next";

const UserForm = ({ handleSubmit, text, userData, handleOpen2FAModal, handleOpenPwdModal}) => {
  const { t, i18n } = useTranslation();
  const { currentUser } = useAppContext();
  const [currentOrgState, setCurrentOrgState] = useState(userData ? userData.orgId : currentUser.orgId); 
  const [currentProjectId, setCurrentProjectId] = useState(userData ? userData.projectId : currentUser.projectId);

  const { data, loading } = useAxiosFetch("/api/projects/byOrg/" + currentOrgState);
  const { data: orgData, loading: orgLoading } = useAxiosFetch("/api/organizations/");

  // Update state when userData changes
  useEffect(() => {
    setCurrentOrgState(userData ? userData.orgId : currentUser.orgId);
    setCurrentProjectId(userData ? userData.projectId : currentUser.projectId);
  }, [userData]);

  if(loading || orgLoading) return t('loading') + "...";

  const handleFormSubmit = (event) => {
    event.preventDefault();

    const form = new FormData(event.target);

    console.log("email", form.get('email'));
    const formData = {
        name: form.get('name'),
        email: form.get('email') || userData?.email,
        role: form.get('role') || userData?.role,
        orgId: form.get('orgId'),
        projectId: form.get('projectId'),
        language: form.get('userLanguage'),
    };

    handleSubmit(formData);
  };

  return (
  <form onSubmit={handleFormSubmit}>

    <Form.Group className="mb-3">
      <Form.Label>{t('name')}</Form.Label>
      <Form.Control as="input" name="name" defaultValue={userData ? userData.name : ""} required />
    </Form.Group>

    <Form.Group className="mb-3">
      <Form.Label>Email {userData && userData.ssoEnabled && (
        <>
        &#8594; <i>connected Microsoft SSO Login</i>&nbsp;<span className="microsoft-logo" />
          </>)}</Form.Label>
      <Form.Control
        type="email"
        name="email"
        defaultValue={userData ? userData.email : ""}
        required
        disabled={(currentUser.role !== "superadmin" && currentUser.role !== "admin") || (userData && userData.ssoEnabled)}
      />
    </Form.Group>

    {userData && userData.id === currentUser.user_id && !userData.ssoEnabled && (
      <Form.Group className="mb-3">
        <Form.Label>{t('password')}</Form.Label>
        <Button className="white-border-btn submit-btn" style={{float: 'none'}} onClick={handleOpenPwdModal}>{t('change_password')}</Button>
      </Form.Group>
    )}

    {userData && userData.id === currentUser.user_id && !userData.ssoEnabled && (
      <Form.Group className="mb-3">
        <Form.Label>{t('2fa')} - {userData.twoFactorEnabled ? t('enabled') + ' ✔' : t('disabled')}</Form.Label>
        <Button className="white-border-btn submit-btn" style={{float: 'none'}}  onClick={handleOpen2FAModal}>
            {userData.twoFactorEnabled ? t('disable') + ' 2FA' : t('enable') + ' 2FA'}
      </Button>
      </Form.Group>
    )}

    {currentUser.role !== "user" &&  (
      <Form.Group className="mb-3">
        <Form.Label>{t('role')}</Form.Label>
        <Form.Select name="role" 
          defaultValue={userData ? userData.role : "user"}
        >
          {currentUser.role === "superadmin" && (<option value="superadmin">Superadmin</option>)}
          <option value="admin">Admin</option>
          <option value="user">User</option>
        </Form.Select>
      </Form.Group>
    )}


    <Form.Group className="mb-3">
      <Form.Label>{t('organization')}</Form.Label>
      <Form.Select name="orgId" defaultValue={userData ? userData.orgId : currentUser.orgId} onChange={(e) => {
            setCurrentOrgState(e.target.value);
            setCurrentProjectId(null);  // reset the projectId when org changes
          }}
          disabled={currentUser.role !== "superadmin"} >
        {orgData.map((item) => {
          return (
            <option key={item["id"]} value={item["id"]}>
              {item.name}
            </option>
          );
        })}

      </Form.Select>
    </Form.Group>

    <Form.Group className="mb-3">
      <Form.Label>{t('domain')}</Form.Label>
      <Form.Select name="projectId" defaultValue={currentProjectId} onChange={(e) => setCurrentProjectId(e.target.value)} disabled={currentUser.role !== "superadmin" && currentUser.role !== "admin"}>
        {data.map((item) => {
          return (
            <option key={item["id"]} value={item["id"]}>
              {item.name}
            </option>
          );
        })}
      </Form.Select>
    </Form.Group>

    {!userData && (
      <Form.Group className="mb-3">
        <Form.Label>{t('language')}</Form.Label>
        <Form.Select name="userLanguage" defaultValue={i18n.language || 'en'}>
          <option value="en">English</option>
          <option value="nl">Nederlands</option>
        </Form.Select>
        <Form.Text className="text-muted">
          {t('user_language_help_text')}
        </Form.Text>
      </Form.Group>
    )}

    <div className="vertical-spacer" />

    <input className="white-border-btn submit-btn" type="submit" value={text} />
  </form>
  );
};

export default UserForm;
